import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import FormGroup from '@mui/material/FormGroup'
import Switch from '@mui/material/Switch'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

const AntSwitch = (props) => (
  <Switch
    {...props}
    sx={{
      width: 28,
      height: 16,
      padding: 0,
      display: 'flex',
      '& .mui-jss-MuiSwitch-switchBase': {
        padding: '2px',
        color: '#9E9E9E',
        '&.Mui-checked': {
          transform: 'translateX(12px)',
          color: '#FFFFFF',
          '& + .mui-jss-MuiSwitch-track': {
            opacity: 1,
            backgroundColor: '#66BB6A',
            borderColor: '#66BB6A',
          },
        },
      },
      '& .mui-jss-MuiSwitch-thumb': {
        width: 12,
        height: 12,
        boxShadow: 'none',
      },
      '& .mui-jss-MuiSwitch-track': {
        border: `1px solid #9E9E9E`,
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: '#FFFFFF'
      },
    }}/>
)

const CustomSwitch = ({ disabled, style, showLabel, value, onChange }) => {

  const [checked, setChecked] = useState(value ? value : false)

  const handleChange = () => {
    setChecked(!checked)
    onChange(!checked)
  }

  useEffect(() => {
    setChecked(value ? value : false)
  }, [value])

  return (
    <FormGroup style={style}>
      <Typography component="div">
        <Grid component="label" container alignItems="center" spacing={1}>
          {showLabel && <Grid item>Off</Grid>}
          <Grid item>
            <AntSwitch
              disabled={disabled}
              checked={value ? value : checked}
              onChange={handleChange}
              name="switch"/>
          </Grid>
          {showLabel && <Grid item>On</Grid>}
        </Grid>
      </Typography>
    </FormGroup>
  )
}

CustomSwitch.propTypes = {
  disabled: PropTypes.bool,
  style: PropTypes.object,
  showLabel: PropTypes.bool,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
}

export default CustomSwitch
